export default __webpack_public_path__ + "static/media/unlabeled.8f7e8fd5.webp";